import React, { useEffect } from "react";
import '../../../App.css';
import './Booking.css';
import Footer from "../../Footer";
import useAutoplayVideo from "../../../hooks/useAutoplayVideo";

export default function Booking() {
    const videoRef = useAutoplayVideo();

    useEffect(() => {
        document.title = 'Book a Coffee Roasting Class — San Jose & Bay Area | OFFF THE ROAST';
    }, []);

    return (
        <>
            {/* Hero Section */}
            <div className='booking-hero'>
                <video ref={videoRef} className='booking-hero-video-desktop' src='/videos/family.mp4' autoPlay loop muted playsInline preload='auto' poster='/images/family-hero-poster.jpg' />
                <img className='booking-hero-video-mobile' src='/images/family.jpg' alt='Family enjoying a coffee roasting class' />
                <div className='booking-hero-content'>
                    <h1>BOOK YOUR EXPERIENCE</h1>
                    <p>JOIN US FOR AN UNFORGETTABLE COFFEE ROASTING WORKSHOP</p>
                    <a
                        className='square-book-btn'
                        href="https://docs.google.com/forms/d/e/1FAIpQLSdQe1mGUOH7HD7Utz_2C1kSZ47TrG7NqnntLGD2Hz-lqvxKag/viewform?usp=publish-editor"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        BOOK NOW
                    </a>
                </div>
            </div>

            {/* Workshop Highlights Section */}
            <section className='booking-highlights'>
                <div className='booking-section-container'>
                    <h2 className='booking-section-title'>WORKSHOP HIGHLIGHTS: WHAT YOU'LL DISCOVER</h2>

                    <div className='highlights-grid'>
                        <div className='highlight-card'>
                            <h3>The Foundation of Flavor</h3>
                            <p>We begin with a deep dive into the global coffee map. You'll learn about various coffee origins, processing methods, green coffee sourcing, and the fundamental science behind a perfect roast.</p>
                        </div>

                        <div className='highlight-card'>
                            <h3>Hands-On Roasting</h3>
                            <p>Under expert guidance, you will select your own beans—choosing between a custom blend or a single-origin—based on our curated recommendations. After a brief safety orientation to ensure a smooth experience, the roasting begins! We will guide you through the process step-by-step to help you achieve professional-grade results.</p>
                        </div>

                        <div className='highlight-card'>
                            <h3>The Ultimate Tasting</h3>
                            <p>Once your beans are roasted, the real fun starts. You'll have the opportunity to brew your creation using either <em>pour-over</em> or <em>espresso</em> methods. This is where you see how your roasting choices translate into the cup.</p>
                        </div>

                        <div className='highlight-card'>
                            <h3>Pack & Take Home</h3>
                            <p>To wrap up the session, you'll label and package your beans just like a professional roastery. You'll leave with your freshly roasted coffee, ready to be enjoyed at home!</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Experience Details Section */}
            <section className='booking-details'>
                <div className='booking-section-container'>
                    <div className='details-wrapper'>
                        <div className='details-box'>
                            <h2>Experience Details</h2>
                            <ul className='details-list'>
                                <li><span className='detail-label'>Price:</span> $125 / guest</li>
                                <li><span className='detail-label'>Duration:</span> 1.5 – 2 Hours</li>
                                <li><span className='detail-label'>Skill Level:</span> Beginner-friendly (No prior experience required!)</li>
                                <li><span className='detail-label'>Location:</span> San Jose, CA (specific address details provided upon booking)</li>
                                <li><span className='detail-label'>Capacity:</span> Private bookings for up to 6 people per session</li>
                                <li className='detail-teambuilding'>Interested in a private session with us? Submit a request by filling out this <a href='https://docs.google.com/forms/d/e/1FAIpQLSdQe1mGUOH7HD7Utz_2C1kSZ47TrG7NqnntLGD2Hz-lqvxKag/viewform?usp=publish-editor' target='_blank' rel='noopener noreferrer'>form</a> here</li>
                            </ul>
                        </div>

                        <div className='details-box'>
                            <h2>What's Included</h2>
                            <ul className='included-list'>
                                <li><span className='included-label'>Your Roast:</span> A 6 oz bag of the beans you roasted during class.</li>
                                <li><span className='included-label'>Exclusive Tasting:</span> A rare opportunity to taste a "Personal Reserve" of rare beans from the instructor's private collection.</li>
                                <li><span className='included-label'>OFFF THE ROAST Swag:</span> OFFF THE ROAST logo sticker.</li>
                                <li><span className='included-label'>Refreshments:</span> Complimentary bottled water and snacks provided.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    )
}
